var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { MatDialog } from '@angular/material/dialog';
import { LimitDialogComponent } from './components/limit-dialog/limit-dialog.component';
import { LegacyDialogComponent, LegacyDialogEnum } from './components/legacy-dialog/legacy-dialog.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { SaveBookmarkDialogComponent, SaveBookmarkDialogMode } from './components/save-bookmark-dialog/save-bookmark-dialog.component';
import { GroupRestrictionDialogComponent } from './components/group-restriction-dialog/group-restriction-dialog.component';
import { ClipboardDialogComponent } from './components/clipboard-dialog/clipboard-dialog.component';
import { WelcomeTourDialogComponent, WelcomeTourEnum } from './components/welcome-tour-dialog/welcome-tour-dialog.component';
import { DomainJoinDialogComponent } from './components/domain-join-dialog/domain-join-dialog.component';
import { AboutDialogComponent } from './components/about-dialog/about-dialog.component';
import { SaveModuleDialogComponent } from './components/save-module-dialog/save-module-dialog.component';
import { NpsDialogComponent } from './components/nps-dialog/nps-dialog.component';
import { ImportModelDialogComponent } from './components/import-model-dialog/import-model-dialog.component';
import { AddTeamModelDialogComponent } from './components/add-team-model-dialog/add-team-model-dialog.component';
import { DialogIds } from './models/dialog-ids';
import { BackgroundColorDialogComponent } from './components/background-color-dialog/background-color-dialog.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
var mobileScreenWidth = 768;
var transparentDialogCSSClass = 'backdropClass';
var DialogService = /** @class */ (function () {
    function DialogService(dialog) {
        this.dialog = dialog;
    }
    Object.defineProperty(DialogService.prototype, "isMobile", {
        get: function () {
            return window.innerWidth <= mobileScreenWidth;
        },
        enumerable: true,
        configurable: true
    });
    DialogService.prototype.openClipboardDialog = function (copyText, config) {
        var options = __assign({ data: {
                id: DialogIds.ClipboardDialog,
                copyText: copyText
            } }, config);
        return this.dialog.open(ClipboardDialogComponent, options);
    };
    DialogService.prototype.openWelcomeTourDialog = function (tourVersion, config) {
        var userType = tourVersion === 'updated_tour' ? WelcomeTourEnum.ExistingUser : WelcomeTourEnum.NewUser;
        var options = __assign({ id: DialogIds.WelcomeTourDialog, disableClose: true, data: {
                userType: userType
            } }, config);
        return this.dialog.open(WelcomeTourDialogComponent, options);
    };
    DialogService.prototype.openJoinDomainDialog = function (organization, config) {
        var options = __assign({ id: DialogIds.JoinDomainDialog, data: {
                organization: organization
            } }, config);
        return this.dialog.open(DomainJoinDialogComponent, options);
    };
    DialogService.prototype.openNpsSurveyDialog = function (surveyGroupName, config) {
        var options = __assign({ id: DialogIds.NpsSurveyDialog, data: {
                surveyGroupName: surveyGroupName
            } }, config);
        return this.dialog.open(NpsDialogComponent, options);
    };
    DialogService.prototype.openConfirmDialog = function (config) {
        var options = __assign({ id: DialogIds.ConfirmDialog }, config);
        return this.dialog.open(ConfirmDialogComponent, options);
    };
    DialogService.prototype.openLimitDialog = function () {
        this.dialog.closeAll();
        return this.dialog.open(LimitDialogComponent, {
            id: DialogIds.LimitDialog,
            width: '480px'
        });
    };
    DialogService.prototype.openUpgradeDialog = function (config) {
        var dimensions = {
            width: 925,
            height: 700
        };
        var options = __assign({ id: DialogIds.UpgradeDialog }, {
            width: dimensions.width + "px",
            height: dimensions.height + "px",
            data: {
                type: LegacyDialogEnum.UpgradeSubscription,
                dimensions: dimensions
            }
        }, config);
        this.dialog.closeAll();
        return this.dialog.open(LegacyDialogComponent, options);
    };
    DialogService.prototype.openBuyDialog = function (config) {
        var dimensions = {
            width: 550,
            height: 650
        };
        var options = __assign({ id: DialogIds.BuyDialog }, {
            width: dimensions.width + "px",
            height: dimensions.height + "px",
            data: {
                type: LegacyDialogEnum.BuySubscription,
                dimensions: dimensions
            }
        }, config);
        this.dialog.closeAll();
        return this.dialog.open(LegacyDialogComponent, options);
    };
    DialogService.prototype.openProfileDialog = function (config, tab) {
        if (tab === void 0) { tab = ''; }
        var dimensions = {
            width: 750,
            height: 600
        };
        var options = __assign({ id: DialogIds.ProfileDialog }, {
            width: dimensions.width + "px",
            height: dimensions.height + "px",
            data: {
                type: LegacyDialogEnum.MyProfile,
                dimensions: dimensions,
                options: {
                    show_tab: tab
                }
            }
        }, config);
        this.dialog.closeAll();
        return this.dialog.open(LegacyDialogComponent, options);
    };
    DialogService.prototype.openSaveModuleDialog = function (id, config) {
        this.dialog.closeAll();
        var options = __assign({ id: DialogIds.SaveModuleDialog }, {
            width: '480px',
            data: {
                id: id
            }
        }, config);
        return this.dialog.open(SaveModuleDialogComponent, options);
    };
    DialogService.prototype.openSaveBookmarkDialog = function (bookmark, config) {
        return this._openSaveBookmarkDialog(__assign({ id: DialogIds.SaveBookmarkDialog, data: {
                bookmark: bookmark,
                mode: SaveBookmarkDialogMode.SaveStory
            } }, config));
    };
    DialogService.prototype.openSaveAsBookmarkDialog = function (title, bookmarkTitle, message, config) {
        return this._openSaveBookmarkDialog(__assign({ id: DialogIds.SaveBookmarkDialog, data: {
                title: title,
                bookmarkTitle: bookmarkTitle,
                message: message,
                mode: SaveBookmarkDialogMode.SaveStory
            } }, config));
    };
    DialogService.prototype.openManageDialog = function (bookmark, config) {
        return this._openSaveBookmarkDialog(__assign({ id: DialogIds.SaveBookmarkDialog, data: {
                bookmark: bookmark,
                mode: SaveBookmarkDialogMode.Manage
            } }, config));
    };
    DialogService.prototype.openBookmarkAccessDialog = function (bookmark, config) {
        var options = __assign({ id: DialogIds.BookmarkAccessDialog, width: '480px', data: {
                model: bookmark
            } }, config);
        this.dialog.closeAll();
        return this.dialog.open(SaveBookmarkDialogComponent, options);
    };
    DialogService.prototype.openGroupRestrictionDialog = function (config) {
        var options = __assign({ id: DialogIds.GroupRestrictionDialog }, {
            width: '480px',
            height: 'auto'
        }, config);
        return this.dialog.open(GroupRestrictionDialogComponent, options);
    };
    DialogService.prototype.openPremiumContentDialog = function () {
        var bodyText = this.isMobile
            ? 'This is premium content. Visit us on desktop to upgrade to a premium plan.'
            : 'This is premium content. Upgrade to a Premium Plan for unlimited access.';
        return this.openConfirmDialog({
            id: DialogIds.PremiumContentDialog,
            data: {
                titleText: 'Premium Content',
                bodyText: bodyText,
                confirmText: 'Go Premium',
                confirmEnabled: !this.isMobile,
                cancelText: 'OK',
                confirmColor: 'warn'
            }
        });
    };
    DialogService.prototype.openAboutDialog = function () {
        this.dialog.closeAll();
        return this.dialog.open(AboutDialogComponent, {
            id: DialogIds.AboutDialog
        });
    };
    DialogService.prototype.openImportDialog = function () {
        this.dialog.closeAll();
        var options = {
            id: DialogIds.ImportDialog,
            maxWidth: '90vw',
            width: '90vw',
            height: '90vh'
        };
        return this.dialog.open(ImportModelDialogComponent, options);
    };
    DialogService.prototype.openAddTeamModelDialog = function (bookmark) {
        var options = {
            id: DialogIds.AddTeamModelDialog,
            data: {
                bookmark: bookmark
            }
        };
        return this.dialog.open(AddTeamModelDialogComponent, options);
    };
    DialogService.prototype.openBackgroundColorDialog = function () {
        var options = {
            backdropClass: transparentDialogCSSClass,
            data: {}
        };
        return this.dialog.open(BackgroundColorDialogComponent, options);
    };
    DialogService.prototype._openSaveBookmarkDialog = function (config) {
        var options = __assign({ mode: SaveBookmarkDialogMode.SaveStory }, config);
        this.dialog.closeAll();
        return this.dialog.open(SaveBookmarkDialogComponent, options);
    };
    DialogService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DialogService_Factory() { return new DialogService(i0.ɵɵinject(i1.MatDialog)); }, token: DialogService, providedIn: "root" });
    return DialogService;
}());
export { DialogService };
